import { createSelector } from '@reduxjs/toolkit';
export const facetResponseSelector = createSelector((state) => state.productListing.facets, (state, facetId) => facetId in state.commerceFacetSet, (_state, facetId) => facetId, (facets, isFacetIdInFacetSet, facetId) => {
    const facetResponse = facets.find((facetResponse) => facetResponse.facetId === facetId);
    if (facetResponse && isFacetIdInFacetSet) {
        return facetResponse;
    }
    return undefined;
});
export const isFacetLoadingResponseSelector = (state) => state.productListing.isLoading;
